export enum VerifyCardType {
  IDENTIFY_CARD = "identify card",
  DRIVER_LICENSE = "drive license",
}
